var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vue-world-map" },
    [
      _c("Map", {
        attrs: { codeLang: _vm.LangUser },
        on: {
          hoverCountry: _vm.onHoverCountry,
          hoverLeaveCountry: _vm.onHoverLeaveCountry
        }
      }),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.legend.name && _vm.notShow,
                expression: "legend.name && notShow"
              }
            ],
            staticClass: "vue-map-legend",
            style:
              "left:" +
              (_vm.position.left + _vm.positionLeftTooltip) +
              "px; top: " +
              (_vm.position.top + _vm.positionTopTooltip) +
              "px;" +
              "box-shadow:" +
              _vm.legendBoxShadowCss +
              "; border: " +
              _vm.legendBorderCss +
              ";"
          },
          [
            _c(
              "div",
              {
                staticClass: "vue-map-legend-header",
                style:
                  "background: " +
                  _vm.legendHeaderBackgroundColor +
                  "; color: " +
                  _vm.legendFontColorHeader
              },
              [
                _vm.notShow
                  ? _c("span", [_vm._v(_vm._s(_vm.legend.name))])
                  : _vm._e()
              ]
            ),
            _c(
              "div",
              {
                staticClass: "vue-map-legend-content",
                style:
                  "background: " +
                  _vm.legendContentBackgroundColor +
                  "; color: " +
                  _vm.legendFontColorContent
              },
              [
                _vm.notShow
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.renderValue(_vm.countryData[_vm.legend.code]) || 0
                        )
                      )
                    ])
                  : _vm._e()
              ]
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }